import * as ko from "knockout";
import entityBase from "entityBase";
import { contact } from "original";

export class product_contact extends entityBase {
  contact_sequence: KnockoutObservable<string>;
  product_id: KnockoutObservable<string>;
  role_type: KnockoutObservable<string>;
  user_def1: KnockoutObservable<string>;
  user_def2: KnockoutObservable<string>;
  user_def3: KnockoutObservable<string>;
  contact: KnockoutObservable<contact>;

  constructor(item: any) {
    super();
    this.contact_sequence = ko.observable(item?.contact_sequence);
    this.product_id = ko.observable(item?.product_id);
    this.role_type = ko.observable(item?.role_type);
    this.user_def1 = ko.observable(item?.user_def1);
    this.user_def2 = ko.observable(item?.user_def2);
    this.user_def3 = ko.observable(item?.user_def3);
    this.contact = <KnockoutObservable<contact>>this.loadRelation(item, contact, "contact");
  }
}
